import Translate from '~/client/shared/i18n/Translate';
import Img from '~/client/shared/images/Img';
import getCdnImg from '~/shared/cdn/getCdnImg';

type Props = {
  prize?: string;
};

const PrizePool: FC<Props> = ({ prize }) => (
  <div className="grid grid-flow-col items-center gap-4">
    <Img className="relative w-12" alt="" src={getCdnImg('cashback-2.png')} />
    <div className="grid grid-rows-[max-content]">
      <p className="text-moon-9 font-semibold uppercase tracking-[1px] text-piccolo">
        <Translate id="game-leaderboard.prize-pool" />
      </p>
      <div className="grid h-8 gap-4 rounded-moon-s-xs bg-gohan">
        <span className="line-clamp-1 text-ellipsis font-headline text-moon-18 text-bulma">
          {prize}
        </span>
      </div>
    </div>
  </div>
);

export default PrizePool;
